import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useSetPledgeShopCharityPercentageMutation = createMutationHook(
  CreatorIntegrationsApiClient.setPledgeShopCharityPercentage,
  {
    mutationKey: ['setPledgeShopCharityPercentage'],
  },
)
